import { useState, useEffect } from "react";
import styles from "../styles/StepTwo.module.css";
import SummarySection from "./SummarySection";
import { FaBottleWater } from "react-icons/fa6";
import ReturnModal from "./ReturnModal";

const StepTwo = ({
    setStep,
    origin,
    destination,
    distance,
    formValues,
    setFormValues,
    duration,
    setOrigin,
    setDestination,
    setDuration,
    setDistance,
    directions,
    setDirections,
}) => {
    const [vehicles, setVehicles] = useState([]);
    const [updatedVehiclesPricing, setUpdatedVehiclesPricing] = useState([]);

    const [originPSCode, setOriginPSCode] = useState("");
    const [destinationPSCode, setDestinationPSCode] = useState("");

    // Define a list of postal codes that fall within the congestion zone
    const congestionZonePostalCodes = [
        "EC1",
        "EC2",
        "EC3",
        "EC4",
        "SE1",
        "SW1",
        "W1",
        "WC1",
        "WC2",
    ];

    // Extract the postal code from the address using a regular expression
    const checkCongestionPostal = () => {
        if (origin && destination) {
            const postalCodeRegex = /\b[A-Z]{1,2}\d[A-Z]{1,2}\b/i; // Regex to extract postal code
            const postalCodeMatch =
                origin.formatted_address.match(postalCodeRegex);
            console.log(postalCodeMatch);
            if (postalCodeMatch) {
                for (let i = 0; i < congestionZonePostalCodes.length; i++) {
                    if (
                        postalCodeMatch[0].startsWith(
                            congestionZonePostalCodes[i]
                        )
                    ) {
                        return true;
                    }
                }
            }
            const postalCodeMatch2 =
                destination.formatted_address.match(postalCodeRegex);
            console.log(postalCodeMatch2);
            if (postalCodeMatch2) {
                for (let i = 0; i < congestionZonePostalCodes.length; i++) {
                    if (
                        postalCodeMatch2[0].startsWith(
                            congestionZonePostalCodes[i]
                        )
                    ) {
                        return true;
                    }
                }
            }
            return false;
        }
    };

    const handleCarSelect = (vehicle) => {
        vehicle.pricing.total = vehicle.pricing.total.toFixed(2);
        setFormValues({
            ...formValues,
            selectedVehicle: vehicle,
            serviceType: "One Way",
            DateTime: `${formValues.pickUpDate} ${formValues.pickUpTime}`,
        });
        setStep(3);
        // setSelectedVehicle(vehicle);
        // if (DoublePrice) {
        //     console.log(vehicle.pricing.total * 2)
        //     vehicle.pricing.total *= 2
        //     setFormValues({ ...formValues, selectedVehicle: vehicle })
        //     setStep(3);
        // } else {
        //     setFormValues({ ...formValues, selectedVehicle: vehicle });
        //     setStep(3);
        // }
    };

    const handleRoundWayTrip = (vehicle) => {
        if (formValues.returnDate && formValues.returnTime) {
            vehicle.pricing.total = vehicle.pricing.total.toFixed(2) * 2;
            setFormValues({
                ...formValues,
                selectedVehicle: vehicle,
                serviceType: "Round Trip",
                DateTime: `${formValues.pickUpDate} ${formValues.pickUpTime}`,
                returnDateTime: `${formValues.returnDate} ${formValues.returnTime}`,
            });
            setStep(3);
        }
    };

    const handleHourlyBooking = (vehicle) => {
        vehicle.pricing.total = (
            vehicle.pricing.perHour * formValues.hours
        ).toFixed(2);
        setFormValues({
            ...formValues,
            selectedVehicle: vehicle,
            DateTime: `${formValues.pickUpDate} ${formValues.pickUpTime}`,
        });
        setStep(3);
    };

    const isAirportArea = () => {
        if (origin && destination) {
            const airportRegex =
                /airport(\s(area|terminal|lounge|\b\w*)|\b\w*airport)/i;
            const address = origin.name + " " + origin.formatted_address;
            const matches = address.match(airportRegex);
            console.log(matches);
            if (matches && matches.length > 0) {
                return true;
            }
            const address2 =
                destination.name + " " + destination.formatted_address;
            const matches2 = address2.match(airportRegex);
            console.log(matches2);
            if (matches2 && matches2.length > 0) {
                return true;
            }
            return false;
        }
    };

    const zonesPostalCode = ["E", "N", "NW", "SE", "SW", "W"];

    const zoneCheck = () => {
        if (origin && destination) {
            const originPostalCode = origin.address_components.filter((value) =>
                value.types.includes("postal_code")
            );
            console.log("Origin Postal Code", originPostalCode);
            if (originPostalCode.length === 0) {
                setOriginPSCode("Other");
                console.log("Origin PS Code", originPSCode);
            } else {
                const [{ long_name: originPostalName }] = originPostalCode;
                console.log("postal_code", originPostalName);
                let stateSet = false;
                for (let i = 0; i < zonesPostalCode.length; i++) {
                    if (originPostalName.startsWith(zonesPostalCode[i])) {
                        setOriginPSCode(zonesPostalCode[i]);
                        stateSet = true;
                        break;
                    }
                }
                if (!stateSet) {
                    setOriginPSCode("Other");
                }
                console.log(
                    "State Update Zone origin Postal Code",
                    originPSCode
                );
            }

            const destinationPostalCode = destination.address_components.filter(
                (value) => value.types.includes("postal_code")
            );
            console.log("Destination Postal Code", destinationPostalCode);
            if (destinationPostalCode.length === 0) {
                setDestinationPSCode("Other");
                console.log("Destination PS Code", destinationPSCode);
            } else {
                const [{ long_name: destinationPostalName }] =
                    destinationPostalCode;
                console.log("postal_code", destinationPostalName);
                let stateSet = false;
                for (let i = 0; i < zonesPostalCode.length; i++) {
                    if (destinationPostalName.startsWith(zonesPostalCode[i])) {
                        setDestinationPSCode(zonesPostalCode[i]);
                        stateSet = true;
                        break;
                    }
                }
                if (!stateSet) {
                    setDestinationPSCode("Other");
                }
                console.log(
                    "State Update Zone Destition Postal Code",
                    destinationPSCode
                );
            }
        }
    };

    const priceCalculation = (perMile015) => {
        console.log("PER MILE", perMile015);
        let originPrice;
        let destinationPrice;

        for (const key in perMile015) {
            if (key === originPSCode) {
                originPrice = perMile015[key];
            }
            if (key === destinationPSCode) {
                destinationPrice = perMile015[key];
            }
        }
        console.log("OriginPriceValue", originPrice);
        console.log("DestiinationPriceValue", destinationPrice);

        return originPrice > destinationPrice ? originPrice : destinationPrice;
    };

    const query = `{
        vehicleCollection{
          items{
            sys {
                id
            }
            id
            name
            description
            passengers
            suitcases
            pricing{
              ... on VehiclePricing{
                name
                perMile
                perHour
                initial
                perMile015
                perMile1550
                perMile50100
                perMile100
              }
            }
            features
            image{
                url
            }
          }
        }
      }`;

    useEffect(() => {
        fetch(
            `https://graphql.contentful.com/content/v1/spaces/z4msozppsnsv/`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Bearer BFP5BxWGezrmeLe8ZS7b7yd-X38VtsLzgSes1kGWHp4",
                },
                body: JSON.stringify({ query }),
            }
        )
            .then((response) => response.json())
            .then(({ data, errors }) => {
                if (errors) {
                    console.error(errors);
                }

                setVehicles(data.vehicleCollection.items);
            });
    }, [query]);

    console.log("vechicle after use effect", vehicles);

    useEffect(() => {
        zoneCheck();
        const isCongestion = checkCongestionPostal();
        const isAirport = isAirportArea();

        // Function to update the total value of a vehicle
        const updateVehicleTotal = () => {
            // Create a new array of vehicles with the updated total value for the specified vehicle index
            if (origin && destination) {
                var newTotal = isAirport ? 10 : 0;
                newTotal = isCongestion ? newTotal + 15 : newTotal;
                console.log(newTotal);
                const regex = /[\d.]+/;
                const distanceNumber = parseFloat(distance.match(regex)[0]);
                const updatedVehicles = vehicles.map((vehicle) => {
                    const highestPrice015 = priceCalculation(
                        vehicle.pricing.perMile015
                    );
                    console.log("Highest Price 0 - 15", highestPrice015);
                    const highestPrice1550 = priceCalculation(
                        vehicle.pricing.perMile1550
                    );
                    console.log("Highest Price 15 - 50", highestPrice1550);
                    const highestPrice50100 = priceCalculation(
                        vehicle.pricing.perMile50100
                    );
                    console.log("Highest Price", highestPrice50100);
                    const highestPrice100 = priceCalculation(
                        vehicle.pricing.perMile100
                    );
                    console.log("Highest Price", highestPrice100);

                    let totalPrice = 0;

                    if (distanceNumber <= 15) {
                        totalPrice = highestPrice015;
                    } else if (distanceNumber > 15 && distanceNumber <= 50) {
                        totalPrice =
                            highestPrice015 +
                            highestPrice1550 * (distanceNumber - 15);
                    } else if (distanceNumber > 50 && distanceNumber <= 100) {
                        totalPrice =
                            highestPrice015 +
                            highestPrice1550 * 35 +
                            highestPrice1550 * (distanceNumber - 50);
                    } else if (distanceNumber > 100) {
                        totalPrice =
                            highestPrice015 +
                            highestPrice1550 * 35 +
                            highestPrice1550 * 50 +
                            highestPrice1550 * (distanceNumber - 100);
                    }
                    return {
                        ...vehicle,
                        pricing: {
                            ...vehicle.pricing,
                            total: newTotal + totalPrice,
                        },
                    };
                });
                updatedVehicles.sort((vehicle) => vehicle.orderNumber);
                // Update the state with the new array of vehicles
                setUpdatedVehiclesPricing(updatedVehicles);
            } else {
                setUpdatedVehiclesPricing(vehicles);
            }
        };

        updateVehicleTotal();
    }, [vehicles, distance]);

    const VehicleList = updatedVehiclesPricing.map((vehicle) => {
        // console.log("Vehicle", vehicle)
        // // console.log(vehicle.name.includes("E-CLASS"))

        // // let pay = ((vehicle.pricing.total.toFixed(2)))
        // // console.log(pay)
        return (
            <div className={`${styles.box}`}>
                {vehicle.name.toLowerCase().includes("e-class") && (
                    <div
                        className={`${styles.ribbon} ${styles.ribbonTopRight}`}
                    >
                        <span>Popular</span>
                    </div>
                )}
                <div className="row">
                    <div className="col-lg-6">
                        <h3 className={`${styles.carTitle}`}>
                            {vehicle["name"]}
                        </h3>
                        <div className="d-flex">
                            <img
                                src="images/people-group-icon.png"
                                alt="Number of passengers"
                            />
                            <span className={`${styles.iconText}`}>
                                Max {vehicle["passengers"]}
                            </span>
                            {/* <div className={`${styles.tooltip}`}> */}
                            <img
                                src="images/luggage-icon.png"
                                alt="Number of suitcases"
                                className="ms-5"
                            />
                            <span className={`${styles.iconText}`}>
                                Max {vehicle["suitcases"]}
                            </span>
                            {/* <span className={`${styles.tooltiptext}`}>
                                    <img
                                        className={`${styles.suitcase}`}
                                        src="images/suitcase.jpeg"
                                        alt="suitcase"
                                    />
                                </span>
                            </div> */}
                        </div>
                        <hr />
                        <div className="d-flex my-2 align-items-center column-gap-3">
                            <img
                                src="images/feature-time.png"
                                alt="wait"
                                // className="img-fluid"
                                width={25}
                                height={25}
                            />
                            <span className={`${styles.featureText}`}>
                                Free 60 minutes wait time for airport pickups,
                                15 mins for all others
                            </span>
                        </div>
                        <div className="d-flex my-2 align-items-center column-gap-3">
                            <img
                                src="images/feature-meet.png"
                                alt="meet and greet"
                                // className="img-fluid"
                                width={25}
                                height={25}
                            />
                            <span className={`${styles.featureText}`}>
                                Includes Meet & Greet
                            </span>
                        </div>
                        <div className="d-flex my-2 align-items-center column-gap-3">
                            <img
                                src="images/feature-cancellation.png"
                                alt="cancellation"
                                // className="img-fluid"
                                width={25}
                                height={25}
                            />
                            <span className={`${styles.featureText}`}>
                                Free cancellation up until 1 hour before pickup
                            </span>
                        </div>
                        <div className="d-flex my-2 align-items-center column-gap-3">
                            <FaBottleWater color="#b68b47" size="25px" />
                            <span className={`${styles.featureText}`}>
                                Complimentary bottled water
                            </span>
                        </div>
                        <div className="d-flex my-2 align-items-center column-gap-3">
                            <img
                                src="images/feature-wifi.png"
                                alt="wifi"
                                // className="img-fluid"
                                width={25}
                                height={25}
                            />
                            <span className={`${styles.featureText}`}>
                                WIFI Available
                            </span>
                        </div>
                        <div className="d-flex my-2 align-items-center column-gap-3">
                            <img
                                src="images/feature-news.png"
                                alt="news"
                                // className="img-fluid"
                                width={25}
                                height={25}
                            />
                            <span className={`${styles.featureText}`}>
                                Newspaper
                            </span>
                        </div>
                    </div>
                    {/* *********************** */}
                    <div className="col-lg-6">
                        {formValues.type === "distance" && (
                            <div class="row gy-3">
                                <div class="col-lg-6">
                                    <div className={`${styles.greyBox}`}>
                                        <h3 className={styles.priceHeading}>
                                            £
                                            {vehicle["pricing"][
                                                "total"
                                            ].toFixed(2)}
                                        </h3>
                                        <p className={styles.priceDesc}>
                                            VAT included.
                                        </p>
                                        <button
                                            className={styles.selectCarBtn}
                                            onClick={() =>
                                                handleCarSelect(vehicle)
                                            }
                                        >
                                            One Way
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className={`${styles.greyBox}`}>
                                        <h3 className={styles.priceHeading}>
                                            £
                                            {vehicle["pricing"][
                                                "total"
                                            ].toFixed(2) * 2}
                                        </h3>
                                        <p className={styles.priceDesc}>
                                            VAT included.
                                        </p>
                                        <ReturnModal
                                            formValues={formValues}
                                            setFormValues={setFormValues}
                                            vehicle={vehicle}
                                            handleRoundWayTrip={
                                                handleRoundWayTrip
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {formValues.type === "hourly" && (
                            <div className={`${styles.greyBox}`}>
                                <h3 className={styles.priceHeading}>
                                    £
                                    {(
                                        vehicle["pricing"]["perHour"] *
                                        formValues.hours
                                    ).toFixed(2)}
                                </h3>
                                <p className={styles.priceDesc}>
                                    VAT included.
                                </p>
                                <button
                                    className={styles.selectCarBtn}
                                    onClick={() => handleHourlyBooking(vehicle)}
                                >
                                    Book Now
                                </button>
                            </div>
                        )}
                        <img
                            src={vehicle["image"]["url"]}
                            alt="mercedes car"
                            className="img-fluid"
                            width={"100%"}
                        />
                    </div>
                    {/* *********************** */}
                </div>
            </div>
        );
    });
    // console.log('dateandtime', formValues.DateTime)

    return (
        <div className="container">
            <nav className="container text-center">
                <img
                    className="img-fluid pt-4"
                    src="images/logo.svg"
                    alt="pegasus chauffeur"
                />
                <p className={`my-5 py-3 text-white ${styles.heading}`}>
                    Use the form below to check the pricing for our all
                    available vehicles. Smart, Secure, Online Payment System
                    designed for our valuable customers.
                </p>
            </nav>
            <img
                src="images/navigation-bar-step2.svg"
                alt="first step"
                className="img-fluid mb-5"
            />
            {formValues.type === "distance" && (
                <div className={`${styles.SummaryBox}`}>
                    <SummarySection
                        origin={origin}
                        destination={destination}
                        distance={distance}
                        duration={duration}
                        // DateTime={`${formValues.DateTime}`}
                        // dateTime={{ DateTime } = formValues}
                        // formValues={formValues}
                        pickUpDate={`${formValues.pickUpDate}`}
                        pickUpTime={`${formValues.pickUpTime}`}
                        setOrigin={setOrigin}
                        setDestination={setDestination}
                        formValues={formValues}
                        setFormValues={setFormValues}
                        setDirections={setDirections}
                        directions={directions}
                        setDistance={setDistance}
                        setDuration={setDuration}
                    />
                </div>
            )}
            {VehicleList}
            <div className="d-flex justify-content-center text-center pb-5">
                <button
                    className={styles.previousBtn}
                    onClick={() => setStep(1)}
                >
                    Go to Previous Page
                </button>
                {/* <button
                    className={styles.nextBtn}
                    onClick={() =>
                        formValues.selectedVehicle ? setStep(1) : setStep(2)
                    }
                >
                    Go to Extras
                </button> */}
            </div>
        </div>
    );
};

export default StepTwo;
